import { t, useLanguage } from "@/i18n/LanguageContext";import { useSite } from "@/context/SiteContext";

export default function PartnerBand() {useLanguage();
  const { content } = useSite();
  const partners = content.partners || [];
  if (!partners.length) return null;
  const row = [...partners, ...partners];

  return (
    <section data-testid="partner-band" className="overflow-hidden border-t border-slate-200 bg-[#F8FAFC] py-10">
      <p data-testid="partner-band-title" className="mb-8 text-center font-mono text-xs uppercase tracking-[0.3em] text-slate-400">{t("I nostri partner")}

      </p>
      <div className="marquee-track-slow flex w-max items-center gap-14 px-7">
        {t(row.map((p, i) =>
        <div key={i} data-testid={i < partners.length ? `partner-${i}` : `partner-copy-${i - partners.length}`} aria-hidden={i >= partners.length ? true : undefined} className="flex items-center gap-3.5 whitespace-nowrap">
            {t(p.logo ?
          <span className={`flex shrink-0 items-center justify-center rounded-lg bg-white p-2 ring-1 ring-slate-200 ${p.imageKind === "header" ? "h-20 w-80" : "h-16 w-32"}`}>
                <img data-testid={`partner-logo-${i}`} src={p.logo} alt={t(`${p.imageKind === "header" ? "Intestazione del sito" : "Logo"} ${p.name}`)} className="h-full w-full object-contain" />
              </span> :

          <span
            data-testid={`partner-monogram-${i}`}
            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-xs font-bold ${
            i % 2 ? "bg-brand-lime text-brand-navydeep" : "bg-brand-navy text-white"}`
            }>
            
                {t(p.initials)}
              </span>)
          }
            <span>
              <span data-testid={`partner-name-${i}`} className="block font-display text-sm font-bold text-brand-navydeep">{t(p.name)}</span>
              <span data-testid={`partner-kind-${i}`} className="block text-[10px] uppercase tracking-widest text-slate-400">{t(p.kind)}</span>
            </span>
          </div>
        ))}
      </div>
    </section>);

}
